import { render, staticRenderFns } from "./InvitationMoneyRechargeWindow.vue?vue&type=template&id=32f3a3b8&scoped=true"
import script from "./InvitationMoneyRechargeWindow.vue?vue&type=script&lang=js"
export * from "./InvitationMoneyRechargeWindow.vue?vue&type=script&lang=js"
import style0 from "./InvitationMoneyRechargeWindow.vue?vue&type=style&index=0&id=32f3a3b8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f3a3b8",
  null
  
)

export default component.exports